import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { ActiveClientFragmentDoc } from '../../../../lib/ui/ActiveClientsAvatarStack.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActiveClientsQueryVariables = Types.Exact<{
  input: Types.ActiveClientsInput;
}>;


export type ActiveClientsQuery = { __typename?: 'Query', ActiveClients: Array<{ __typename?: 'ActiveClient', promptUuid?: string | null, courseVersionId?: number | null, moduleVersionId?: string | null, skillVersionId?: string | null, verificationStepId?: string | null, moduleContentMembershipId?: string | null, richTextDocumentId?: string | null, workflowVersionId?: string | null, clientId: string, user: { __typename?: 'Employee', id: number, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null } }> };


export const ActiveClientsDocument = gql`
    query ActiveClients($input: ActiveClientsInput!) {
  ActiveClients: AdminActiveClients(input: $input) {
    ...ActiveClient
  }
}
    ${ActiveClientFragmentDoc}`;

/**
 * __useActiveClientsQuery__
 *
 * To run a query within a React component, call `useActiveClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveClientsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActiveClientsQuery(baseOptions: Apollo.QueryHookOptions<ActiveClientsQuery, ActiveClientsQueryVariables> & ({ variables: ActiveClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveClientsQuery, ActiveClientsQueryVariables>(ActiveClientsDocument, options);
      }
export function useActiveClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveClientsQuery, ActiveClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveClientsQuery, ActiveClientsQueryVariables>(ActiveClientsDocument, options);
        }
export type ActiveClientsQueryHookResult = ReturnType<typeof useActiveClientsQuery>;
export type ActiveClientsLazyQueryHookResult = ReturnType<typeof useActiveClientsLazyQuery>;
export type ActiveClientsQueryResult = Apollo.QueryResult<ActiveClientsQuery, ActiveClientsQueryVariables>;